import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=50b151c8&scoped=true"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=50b151c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b151c8",
  null
  
)

export default component.exports